import StickySidebar from 'sticky-sidebar'

export default (_ctx, inject) => {
  inject('stickySidebar', element => new StickySidebar(element))
}
